import {trimEnd} from 'lodash';

export const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
};

export function getJsonFromUrl(url) {
    const query = url.substr(1);
    const result = {};
    query.split('&').forEach((part) => {
        const item = part.split('=');
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}

export const abiturBall = (ball) => {
    return trimEnd(trimEnd(ball, '0'), '.');
};
